import React from "react";
import Netsuke from "./Netsuke";
import renderInlineHtml from "~/utils/renderInlineHtml";

export default function Loading({ text }) {
  return (
    <div
      className="dots-background fixed inset-0 flex flex-col items-center justify-center space-y-8 bg-white"
      style={{
        zIndex: 2000,
      }}
    >
      <Netsuke animated />
      {text && (
        <div className="mt-4 text-sm text-neutral-800">
          {renderInlineHtml(text)}
        </div>
      )}
    </div>
  );
}
